import { SourcingService } from 'api-clients/monolith';

import { QueryParams } from '@/hooks/use-filter-query';

export function getLocations(params: QueryParams) {
  return SourcingService.getInternalApiSourcingLocations(
    params.page,
    params.perPage,
    params.sortBy,
    params.sortDirection,
    params.query,
    params.isSelectedForSourcing,
  );
}
